import { useQuery } from "@tanstack/react-query";

import { getPrintConfig, type PrintConfig } from "@/api/print-image-api";
import { FIVE_MINUTES_MS } from "@/constants";

type DropdownOption = {
	key: number;
	text: string;
	value: string;
};

type PrintConfigOptions = {
	colorProfiles: DropdownOption[];
	colorModes: DropdownOption[];
	colorants: DropdownOption[];
};

const formatConfigToOptions = (config: PrintConfig): PrintConfigOptions => ({
	colorProfiles: config.ColorProfiles.map((profile, i) => ({
		key: i,
		text: profile,
		value: profile.toLowerCase(),
	})),
	colorModes: config.ColorModes.map((mode, i) => ({
		key: i,
		text: mode,
		value: mode.toLowerCase(),
	})),
	colorants: config.Colorants.map((colorant, i) => ({
		key: i,
		text: colorant,
		value: colorant.toLowerCase(),
	})),
});

export const usePrintConfig = (iotEdgeDeviceId: string, iotHubName: string) => {
	const query = useQuery({
		queryKey: ["print-config", iotEdgeDeviceId, iotHubName],
		queryFn: () => getPrintConfig(iotEdgeDeviceId, iotHubName),
		enabled: Boolean(iotEdgeDeviceId && iotHubName),
		select: formatConfigToOptions,
		staleTime: FIVE_MINUTES_MS,
		retry: false,
	});

	return {
		colorProfiles: query.data?.colorProfiles ?? [],
		colorModes: query.data?.colorModes ?? [],
		colorants: query.data?.colorants ?? [],
		isLoading: query.isLoading,
		error: query.error,
	};
};
